import React from 'react';
import { TermDetailsAccountConnection } from '@css-xp/graphtypes/src/generated-types-new';
import { TermDetailsAssociatedAccountsTable } from './term-details-associated-accounts-table';

interface Props {
  label?: string;
  isLoading: boolean;
  associatedAccounts: TermDetailsAccountConnection | undefined | null;
}

export const TermDetailsAssociatedAccountsTab: React.FC<Props> = ({ isLoading, associatedAccounts }) => {
  return (
    <div className="associated-accounts-table-container">
      <TermDetailsAssociatedAccountsTable isLoading={isLoading} associatedAccounts={associatedAccounts} />
    </div>
  );
};

export default TermDetailsAssociatedAccountsTab;
